import { createContext, useContext } from 'react';

interface IZendeskChatContextProps {
  isZendeskChatOpen: boolean;
  openChat: ({ partnerSlug, reloadPage }: { partnerSlug: string; reloadPage?: boolean }) => Promise<void>;
  isScriptLoading: boolean;
}

export const ZendeskChatContext = createContext<IZendeskChatContextProps>({
  isZendeskChatOpen: false,
  openChat: () => Promise.resolve(),
  isScriptLoading: false,
});

export const useZendeskChat = () => {
  const context = useContext(ZendeskChatContext);
  if (!context) {
    throw new Error('useZendeskChat must be used within a ZendeskChatContextProvider');
  }
  return context;
};
